import React from 'react';
import styles from './Field.module.scss';
import EditableField from './EditableField';
import { DateComponent } from 'app/components/RsdForms/CreateMoment/components/DateComponent';
import LDAPUserSearchField from '../../shared/LDAPSearch/LDAPSearchField';

interface FieldConfig {
  label: string;
  value: string;
  options?: string[];
  onChange?: (value: string) => void;
  id: string;
  key?: string;
  type?: string;
  required?: boolean;
}

interface FieldProps {
  config: FieldConfig;
  isPhased?: boolean;
}

const Field: React.FC<FieldProps> = ({ config, isPhased = false }) => {
  const { label, value, options, onChange, id, key, type, required } = config;

  if (id === 'releaseDate' || id === 'marketingMoment') {
    // Use DateComponent for these fields, matching the structure of other fields
    return (
      <div
        className={`${styles.fieldContainer} ${
          isPhased ? styles.phasedLayout : ''
        }`}
      >
        <div className={styles.label}>{label}</div>
        <div className={styles.valueContainer}>
          <DateComponent
            field={{
              id,
              name: id,
              label,
              type: type || 'datepicker',
              required: !!required
            }}
            value={value}
            onChange={(name, val) => onChange && onChange(val)}
            hideLabel={true}
            minimal={true}
          />
        </div>
      </div>
    );
  }

  if (options && onChange) {
    return (
      <EditableField
        label={label}
        value={value}
        options={options}
        onChange={onChange}
        id={id}
      />
    );
  }

  return (
    <div
      className={`${styles.fieldContainer} ${
        isPhased ? styles.phasedLayout : ''
      }`}
      data-testid={`field-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div
        className={styles.label}
        data-testid={`field-label-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        {label}
      </div>
      <div
        className={styles.value}
        data-testid={`field-value-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        {value}
      </div>
    </div>
  );
};

export default Field;
